import {useLayoutStore} from '~/store/layout'

export default defineNuxtRouteMiddleware((to) => {
    useLayoutStore().setCurrentModule(to.meta?.module || 'dashboard')
})